import { Component, OnInit, HostListener, ElementRef, NgZone, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
const $ = jQuery;
@Component({
  selector: 'app-cierant-dropdown-searchable',
  templateUrl: './cierant-dropdown-searchable.component.html',
  styleUrls: ['./cierant-dropdown-searchable.component.scss']
})
export class CierantDropdownSearchableComponent implements OnInit, OnChanges {
  @HostListener('document:click', ['$event'])
  clickout(event) {
    const elementText = $(this.eRef.nativeElement).text();
    console.log()
  }
  itemsActive = false;
  searchTerm = "";
  @Input() placeholder: string;
  @Input() multiple: boolean;
  @Input() externalSearch: boolean;
  @Input() disabled: boolean;

  @Input() config = {
    searchableField: "name",
    titleField: "name",
    idField: 'id'
  }
  @Input() items = [
    {
      name: "Item 1",
      id: 1
    },
    {
      name: "Item 2",
      id: 2
    },
    {
      name: "Item 3",
      id: 3
    }
  ];
  filteredItems = [];
  @Output() itemsValueChange = new EventEmitter();
  @Output() searchTermValueChange = new EventEmitter();

  constructor(
    private eRef: ElementRef,
    private ngZone: NgZone
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('changes', changes)
    if (changes.items) {
      this.items = changes.items.currentValue;
      this.filteredItems = this.items;
    }
  }

  ngOnInit() {
    this.filteredItems = this.items;
    const self = this;
    $(document).click(function(event) {
      //if you click on anything except the modal itself or the "open modal" link, close the modal
      if (!$(event.target).closest("app-cierant-dropdown-searchable,.cierant-searchable-selected-container,.cierant-searchable-selected-text,.cierant-searchable-content,.cierant-searchable-input,cierant-searchable-input [type=text],.cierant-searchable-item").length) {
        console.log('teste');
        self.ngZone.run(() => {
          self.itemsActive = false;
        })
      }
    });
  }

  selectItem(item) {
    console.log(item)
    if (!this.multiple && this.items && this.items.filter(i => (i as any).selected).length > 0) {
      this.items.find(i => (i as any).selected)["selected"] = false;
    }
    const idField = this.config.idField || 'id';
    this.filteredItems.find(i => i[idField] == item[idField])['selected'] = true;
    this.items.find(i => i[idField] == item[idField])['selected'] = true;
    this.itemsValueChange.emit(this.items);
  }

  deselectITem(item) {
    const idField = this.config.idField || 'id';
    this.items.find(i => i[idField] == item[idField])['selected'] = false;
    this.filteredItems.find(i => i[idField] == item[idField])['selected'] = false;
    this.itemsValueChange.emit(this.items);
  }

  getSelectedItems() {
    if (!this.items) {
      return [];
    }
    return this.items.filter(i => i['selected']);
  }

  getNotSelectedItems() {
    if (!this.filteredItems) {
      return [];
    }
    return this.filteredItems.filter(i => !i['selected']);
  }

  serachTimeout;
  searchItems() {
    if (this.externalSearch) {
      if (this.serachTimeout) {
        clearTimeout(this.serachTimeout)
      }
      this.serachTimeout = setTimeout(() => {
        this.searchTermValueChange.emit(this.searchTerm);
      }, 1500);
      return;
    }

    if (!this.items) {
      return [];
    }
    if (!this.searchTerm) {
      this.filteredItems = this.items;
      return;
    }
    this.filteredItems = this.items.filter(i => i[this.config.searchableField].toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1);
  }

  getPlaceholder() {
    let searchPlaceholder = this.placeholder || 'Select...';
    const items = this.getSelectedItems();
    if (items && items.length > 0) {
      searchPlaceholder = items[0][this.config.searchableField];
      if (items.length > 1) {
        searchPlaceholder += ` + ${items.length - 1} more...`
      }
    }
    return searchPlaceholder;
  }

  resetSelected() {
    if (!this.items) {
      return;
    }
    this.items.forEach(item => {
      item['selected'] = false;
    });

    if (!this.filteredItems) {
      return;
    }
    this.filteredItems.forEach(item => {
      item['selected'] = false;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/cierant-dropdown-searchable/cierant-dropdown-searchable.component.ts